import { z } from 'zod';
import { jsonValue } from '@common/utils/dynamicConfig/firebase/FirebaseValueSchemas';

export const defaultTestDynamicConfig = {
  testString: 'test',
  testNumber: 100,
};

/**
 * A general interface for test dynamic configuration.
 */
export const testDynamicConfigSchema = jsonValue.pipe(
  z
    .object({
      testString: z.string().min(1).default(defaultTestDynamicConfig.testString),
      testNumber: z.number().default(defaultTestDynamicConfig.testNumber),
    })
    .default(defaultTestDynamicConfig),
);

export type ITestDynamicConfig = z.infer<typeof testDynamicConfigSchema>;
